import { 
  orderEventsInfoCurrent,
  findOrderEventInfoAll,
  orderEventNotificactionCurrent
} from '../../src/application/computed/orderEvents.js';


// Application state: plain values

const state = {

  // coda richieste ordine

  dataOrderStates: [],

  // dati delle viste

  dataEventiOrdine: null,
  dataEventiNotifiche: [],

  dataClients: [],
  dataClientsParams: [],
  dataClient: {},

  dataContacts: [],
  dataContactsParams: [],

  dataOrders: [],
  dataOrdersParams: {},
  dataOrdersClient: [],
  dataOrder: {},
  dataOrderVestizione: {},

  dataOrderSets: [],

  dataOrderRelations: {},

  colliOrdine: [],

  dataReclamo: {
    type: null,
    section: 0,
    rows: [],
    pictures: [],
    note: ""
  },

  data3dviewer: {},
  dataAutorizzazioni: {},

  dataInvoices: [],
  dataInvoicesParams: {},
  dataInvoicesParams2: {},
  dataInvoicePreview: "",

  dataPayments: [],
  dataPaymentsParams: {},

  dataUserDetails: {},

  dataDDT: [],
  dataDDTParams: {},

  dataSostituzioni: [],
  //dataSostituzioniParams: {},

  dataPortafoglioordini: [],
  
  dataPortafoglioreclami: [],

  // info file delle pratiche

  dataDocumentActive: [],
  dataDocumentInfo: {},
  ordersetsParams: {},

  filterBlocked: false,
  filterPending: false

}

// Application state: computed values
const computedState = {
  orderEventsInfoCurrent,
  findOrderEventInfoAll,
  orderEventNotificactionCurrent
}

export {state,computedState};